import React from 'react';

import leftArrow from '../../assets/images/gallery-left.png';

// const arrow = ' < ';
const LeftArrow = props => {
  // console.log('props: ', props);
  return (
    <div
      className={`${props.className} backArrow br-100 flex justify-center`}
      style={{
        // background: '#959595',
        width: '80px',
        height: '80px'
      }}
      onClick={props.goToPrevSlide}
    >
      {/* {arrow} */}
      <img src={leftArrow} alt="left-arrow" />
    </div>
  );
};

export default LeftArrow;
